/* Merry Nutmas lander
   Gallery, deal cards (1 or 2 jumpers), one colour + size picker per jumper, size guide modal,
   Christmas cut-off banner, delivery countdown, FAQ accordion, sticky bar and the cart drawer.
   The drawer shows Shopify's real cart (the automatic 2-jumper discount included) and never locks
   checkout; with one jumper in the cart it offers a second for the mate. */
(() => {
  const init = (root) => {
    /* ---------------- Data rendered by Liquid ---------------- */
    let data = { connected: false, cur: 'GBP', localeTag: 'en-GB', defaultPack: '2', colours: [], sizes: [], variants: [], moneySample: '£1,234.56', cutoff: '', labels: {}, s: {} };
    try {
      const raw = root.querySelector('[data-mn-data]');
      if (raw) data = Object.assign(data, JSON.parse(raw.textContent));
    } catch (error) { /* keep defaults */ }
    // Shopify HTML-escapes translations, and the script writes these strings as plain text.
    const decode = (value) => {
      if (typeof value !== 'string' || value.indexOf('&') === -1) return value;
      const box = document.createElement('textarea');
      box.innerHTML = value;
      return box.value;
    };
    const S = data.s || {};
    Object.keys(S).forEach((key) => { S[key] = decode(S[key]); });
    data.moneySample = decode(data.moneySample);
    const fill = (template, values) => Object.keys(values).reduce((text, key) => text.split(`[${key}]`).join(values[key]), String(template || ''));
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const fitters = [];

    /* ---------------- Money, formatted like the store's own format for this currency ---------------- */
    const moneyFormat = (() => {
      const sample = String(data.moneySample || '');
      let m = sample.match(/^(.*?)1(\D?)234(\D)56(.*)$/);
      if (m) return { prefix: m[1], thousands: m[2], decimal: m[3], suffix: m[4], decimals: 2 };
      m = sample.match(/^(.*?)1(\D?)235(.*)$/); // currencies without decimals round 1234.56 to 1,235
      if (m) return { prefix: m[1], thousands: m[2], decimal: '', suffix: m[3], decimals: 0 };
      return null;
    })();
    const formatMoney = (minor) => {
      const value = Number(minor || 0) / 100;
      if (!moneyFormat) return value.toFixed(2);
      const [whole, frac] = value.toFixed(moneyFormat.decimals).split('.');
      const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, moneyFormat.thousands);
      return moneyFormat.prefix + grouped + (moneyFormat.decimals ? moneyFormat.decimal + frac : '') + moneyFormat.suffix;
    };

    /* ---------------- Scroll lock shared by the drawer and the size guide ---------------- */
    let locks = 0;
    const lockScroll = (on) => {
      locks = Math.max(0, locks + (on ? 1 : -1));
      const value = locks ? 'hidden' : '';
      document.documentElement.style.overflow = value;
      // Horizon scrolls .page-wrapper instead of the document on wide screens, so lock that too.
      const wrapper = document.querySelector('.page-wrapper');
      if (wrapper) wrapper.style.overflow = value;
    };

    /* ---------------- Christmas cut-off banner ---------------- */
    const banner = root.querySelector('[data-cutoff-banner]');
    if (banner && banner.dataset.cutoff) {
      // en-CA formats dates as YYYY-MM-DD, so the London date compares directly with the setting.
      const today = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
      if (today > banner.dataset.cutoff) banner.hidden = true;
    }

    /* ---------------- Gallery ---------------- */
    const track = root.querySelector('[data-gallery-track]');
    const slides = track ? [...track.querySelectorAll('[data-gallery-slide]')] : [];
    const thumbs = [...root.querySelectorAll('[data-gallery-tab]')];
    let index = 0;
    const setIndex = (next, scroll = true) => {
      if (!slides.length) return;
      index = (next + slides.length) % slides.length;
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-selected', String(i === index));
      });
      if (scroll && track) track.scrollTo({ left: index * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      const activeThumb = thumbs[index];
      if (activeThumb && activeThumb.parentElement) {
        const rail = activeThumb.parentElement;
        rail.scrollTo({ left: Math.max(0, activeThumb.offsetLeft - (rail.clientWidth - activeThumb.clientWidth) / 2), behavior: 'smooth' });
      }
    };
    if (track && slides.length > 1) {
      let raf = 0;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== index) setIndex(i, false);
        });
      }, { passive: true });
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => setIndex(i)));
      root.querySelectorAll('[data-gallery-prev]').forEach((btn) => btn.addEventListener('click', () => setIndex(index - 1)));
      root.querySelectorAll('[data-gallery-next]').forEach((btn) => btn.addEventListener('click', () => setIndex(index + 1)));
      // Tap zones: left 42.5% = previous, right 42.5% = next. Swipes never fire a click.
      track.addEventListener('click', (event) => {
        const rect = track.getBoundingClientRect();
        if (!rect.width) return;
        const ratio = (event.clientX - rect.left) / rect.width;
        if (ratio < 0.425) setIndex(index - 1);
        else if (ratio > 0.575) setIndex(index + 1);
      });
      let resizeTimer = 0;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => track.scrollTo({ left: index * track.clientWidth }), 120);
      });
    } else {
      root.querySelectorAll('[data-gallery-prev], [data-gallery-next]').forEach((btn) => { btn.hidden = true; });
    }

    /* ---------------- Deals + one picker per jumper ---------------- */
    const dealCards = [...root.querySelectorAll('[data-pack]')];
    const rowsEl = root.querySelector('[data-rows]');
    const atcButton = root.querySelector('[data-atc]');
    const colours = data.colours && data.colours.length ? data.colours : [{ value: 'Red', hex: '#B3262E' }, { value: 'Green', hex: '#5A7A3A' }];
    const sizes = data.sizes && data.sizes.length ? data.sizes : ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];
    const otherColour = (taken) => (colours.find((c) => c.value !== taken) || colours[0]).value;
    let pack = data.defaultPack === '1' ? 1 : 2;
    let jumpers = [{ colour: colours[0].value, size: '' }];
    if (pack === 2) jumpers.push({ colour: otherColour(jumpers[0].colour), size: '' });
    const notes = {}; // row index -> { text, hint }

    const syncDeals = () => dealCards.forEach((card) => {
      const on = Number(card.dataset.pack) === pack;
      card.classList.toggle('is-selected', on);
      card.setAttribute('aria-checked', String(on));
    });
    const buildRow = (jumper, i) => {
      const row = document.createElement('div');
      row.className = 'mn-row';
      row.dataset.row = String(i);
      const head = document.createElement('div');
      head.className = 'mn-row__head';
      const label = document.createElement('span');
      label.className = 'mn-row__label';
      label.textContent = fill(S.jumper, { n: i + 1 });
      const colourName = document.createElement('span');
      colourName.className = 'mn-row__colour';
      colourName.dataset.rowColour = '';
      colourName.textContent = jumper.colour;
      const guideLink = document.createElement('button');
      guideLink.type = 'button';
      guideLink.className = 'mn-row__guide';
      guideLink.dataset.guideOpen = '';
      guideLink.textContent = S.guide || 'Size guide';
      head.append(label, colourName, guideLink);

      const controls = document.createElement('div');
      controls.className = 'mn-row__controls';
      const swatches = document.createElement('div');
      swatches.className = 'mn-swatches';
      swatches.setAttribute('role', 'radiogroup');
      swatches.setAttribute('aria-label', fill(S.colourLabel, { n: i + 1 }));
      colours.forEach((c) => {
        const on = c.value === jumper.colour;
        const swatch = document.createElement('button');
        swatch.type = 'button';
        swatch.className = 'mn-swatch';
        swatch.setAttribute('role', 'radio');
        swatch.setAttribute('aria-checked', String(on));
        swatch.setAttribute('aria-label', c.value);
        swatch.tabIndex = on ? 0 : -1;
        swatch.dataset.colour = c.value;
        swatch.style.setProperty('--c', c.hex);
        swatches.appendChild(swatch);
      });
      const sizeLabel = document.createElement('label');
      sizeLabel.className = 'mn-size';
      const hidden = document.createElement('span');
      hidden.className = 'mn-hidden';
      hidden.textContent = fill(S.sizeLabel, { n: i + 1 });
      const select = document.createElement('select');
      select.dataset.size = '';
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.disabled = true;
      placeholder.textContent = S.sizePlaceholder || 'Pick size';
      select.appendChild(placeholder);
      sizes.forEach((size) => {
        const option = document.createElement('option');
        option.value = size;
        option.textContent = size;
        select.appendChild(option);
      });
      select.value = jumper.size || '';
      if (!jumper.size) placeholder.selected = true;
      select.classList.toggle('is-empty', !jumper.size);
      sizeLabel.append(hidden, select);
      controls.append(swatches, sizeLabel);

      const note = document.createElement('p');
      note.className = 'mn-row__error';
      note.dataset.rowError = '';
      note.setAttribute('role', 'alert');
      const current = notes[i];
      note.hidden = !current;
      if (current) {
        note.textContent = current.text;
        note.classList.toggle('is-hint', Boolean(current.hint));
        row.classList.toggle('has-error', !current.hint);
      }
      row.append(head, controls, note);
      return row;
    };
    const renderRows = () => {
      if (!rowsEl) return;
      rowsEl.textContent = '';
      jumpers.forEach((jumper, i) => rowsEl.appendChild(buildRow(jumper, i)));
    };
    const setNote = (i, text, hint = false) => {
      if (text) notes[i] = { text, hint };
      else delete notes[i];
      const row = rowsEl && rowsEl.querySelector(`[data-row="${i}"]`);
      if (!row) return;
      const note = row.querySelector('[data-row-error]');
      note.hidden = !text;
      note.textContent = text || '';
      note.classList.toggle('is-hint', Boolean(text && hint));
      row.classList.toggle('has-error', Boolean(text && !hint));
    };
    const focusRow = (i) => {
      const row = rowsEl && rowsEl.querySelector(`[data-row="${i}"]`);
      if (!row) return;
      row.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      const select = row.querySelector('select');
      if (select) window.setTimeout(() => select.focus({ preventScroll: true }), reduceMotion ? 0 : 350);
    };
    // 2 -> 1 keeps Jumper 1; 1 -> 2 adds Jumper 2 in the colour not already picked.
    const setPack = (next) => {
      const n = Number(next) === 1 ? 1 : 2;
      if (n !== pack) {
        pack = n;
        if (pack === 1) {
          jumpers = jumpers.slice(0, 1);
          delete notes[1];
        } else if (jumpers.length < 2) {
          jumpers.push({ colour: otherColour(jumpers[0].colour), size: '' });
        }
        renderRows();
      }
      syncDeals();
    };
    dealCards.forEach((card) => {
      card.addEventListener('click', () => setPack(card.dataset.pack));
      card.addEventListener('keydown', (event) => {
        if ((event.key === 'Enter' || event.key === ' ') && event.target === card) {
          event.preventDefault();
          setPack(card.dataset.pack);
        }
      });
    });
    if (rowsEl) {
      rowsEl.addEventListener('click', (event) => {
        const swatch = event.target.closest('.mn-swatch');
        if (!swatch) return;
        const i = Number(swatch.closest('[data-row]').dataset.row);
        if (!jumpers[i]) return;
        jumpers[i].colour = swatch.dataset.colour;
        const old = rowsEl.querySelector(`[data-row="${i}"]`);
        const fresh = buildRow(jumpers[i], i);
        old.replaceWith(fresh);
        const checked = fresh.querySelector('.mn-swatch[aria-checked="true"]');
        if (checked) checked.focus();
      });
      rowsEl.addEventListener('keydown', (event) => {
        const steps = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
        const swatch = event.target.closest('.mn-swatch');
        if (!swatch || !(event.key in steps)) return;
        event.preventDefault();
        const list = [...swatch.parentElement.querySelectorAll('.mn-swatch')];
        list[(list.indexOf(swatch) + steps[event.key] + list.length) % list.length].click();
      });
      rowsEl.addEventListener('change', (event) => {
        const select = event.target.closest('select[data-size]');
        if (!select) return;
        const i = Number(select.closest('[data-row]').dataset.row);
        if (!jumpers[i]) return;
        jumpers[i].size = select.value;
        select.classList.toggle('is-empty', !select.value);
        setNote(i, '');
      });
    }
    root.querySelectorAll('[data-pick-duo]').forEach((link) => link.addEventListener('click', (event) => {
      event.preventDefault();
      setPack(2);
      const deals = root.querySelector('[data-deals]');
      if (deals) deals.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }));

    /* ---------------- Size guide modal ---------------- */
    const guide = root.querySelector('[data-guide]');
    let guideTrigger = null;
    const focusables = (container) => [...container.querySelectorAll('button:not([disabled]), a[href], select, [tabindex]:not([tabindex="-1"])')].filter((el) => el.offsetParent !== null);
    const openGuide = (trigger) => {
      if (!guide || !guide.hidden) return;
      guideTrigger = trigger || document.activeElement;
      guide.hidden = false;
      lockScroll(true);
      const close = guide.querySelector('.mn-modal__close');
      if (close) close.focus();
    };
    const closeGuide = () => {
      if (!guide || guide.hidden) return;
      guide.hidden = true;
      lockScroll(false);
      if (guideTrigger && typeof guideTrigger.focus === 'function') guideTrigger.focus();
    };
    root.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-guide-open]');
      if (opener) { event.preventDefault(); openGuide(opener); }
    });
    if (guide) {
      guide.querySelectorAll('[data-guide-close]').forEach((btn) => btn.addEventListener('click', closeGuide));
      guide.querySelectorAll('[data-unit]').forEach((btn) => btn.addEventListener('click', () => {
        const inches = btn.dataset.unit === 'in';
        guide.querySelectorAll('[data-unit]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
        guide.querySelectorAll('td[data-cm]').forEach((cell) => {
          const cm = Number(cell.dataset.cm);
          cell.textContent = inches ? (cm / 2.54).toFixed(1) : String(cm);
        });
      }));
      guide.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const list = focusables(guide.querySelector('.mn-modal__panel'));
        if (!list.length) return;
        const first = list[0];
        const last = list[list.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
    }

    /* ---------------- Delivery countdown ---------------- */
    const initDelivery = (delivery) => {
      const CUTOFF_HOUR = Number(delivery.dataset.cutoffHour || 17);
      const MIN_DAYS = Number(delivery.dataset.minDays || 10);
      const MAX_DAYS = Number(delivery.dataset.maxDays || MIN_DAYS);
      const WORK_DAYS = (delivery.dataset.workDays || '1,2,3,4,5').split(',').map((d) => Number(d.trim()));
      const useUkHolidays = (delivery.dataset.holidays || '') === 'GB';
      let localeTag = delivery.dataset.locale || data.localeTag || 'en-GB';
      // English outside the US/Canada uses British date order and spelling (Thu 7 Aug).
      if (/^en-/i.test(localeTag) && !/^en-(US|CA)/i.test(localeTag)) localeTag = 'en-GB';
      const DAY = 86400000;
      const utcDate = (y, m, d) => new Date(Date.UTC(y, m, d));
      const addDays = (d, n) => new Date(d.getTime() + n * DAY);
      const key = (d) => d.toISOString().slice(0, 10);
      const easterSunday = (y) => {
        const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
        const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
        const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
        const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
        return utcDate(y, month - 1, day);
      };
      const firstMonday = (y, m) => { let d = utcDate(y, m, 1); while (d.getUTCDay() !== 1) d = addDays(d, 1); return d; };
      const lastMonday = (y, m) => { let d = utcDate(y, m + 1, 0); while (d.getUTCDay() !== 1) d = addDays(d, -1); return d; };
      const holidayCache = {};
      const bankHolidays = (y) => {
        if (holidayCache[y]) return holidayCache[y];
        const set = new Set();
        const easter = easterSunday(y);
        [addDays(easter, -2), addDays(easter, 1), firstMonday(y, 4), lastMonday(y, 4), lastMonday(y, 7)].forEach((d) => set.add(key(d)));
        [utcDate(y, 0, 1), utcDate(y, 11, 25), utcDate(y, 11, 26)].forEach((d) => {
          let s = d;
          while (s.getUTCDay() === 0 || s.getUTCDay() === 6 || set.has(key(s))) s = addDays(s, 1);
          set.add(key(s));
        });
        holidayCache[y] = set;
        return set;
      };
      const isBusinessDay = (d) => WORK_DAYS.includes(d.getUTCDay()) && (!useUkHolidays || !bankHolidays(d.getUTCFullYear()).has(key(d)));
      const nextBusinessDay = (d) => { let n = addDays(d, 1); while (!isBusinessDay(n)) n = addDays(n, 1); return n; };
      const addBusinessDays = (d, n) => { let cur = d; for (let i = 0; i < n; i++) cur = nextBusinessDay(cur); return cur; };
      // Orders are processed on UK time, so the cut-off is always London time.
      const londonNow = () => {
        const parts = {};
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
          .formatToParts(new Date()).forEach((p) => { if (p.type !== 'literal') parts[p.type] = parseInt(p.value, 10); });
        return { today: utcDate(parts.year, parts.month - 1, parts.day), minutes: parts.hour * 60 + parts.minute };
      };
      const makeFormatter = (options) => {
        try { return new Intl.DateTimeFormat(localeTag, options); } catch (error) { return new Intl.DateTimeFormat('en-GB', options); }
      };
      const fmt = makeFormatter({ weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
      const unit = (n, u) => (u && u.length > 1 ? `${n} ${u}` : `${n}${u || ''}`);
      const textEl = delivery.querySelector('[data-delivery-text]');
      const template = S.timer || 'Order within [countdown] → FREE delivery by [date] (est.)';
      const fit = () => {
        delivery.classList.remove('mn-delivery--wrap');
        delivery.style.fontSize = '';
        if (!delivery.clientWidth) return;
        const overflows = () => delivery.scrollWidth > delivery.clientWidth + 1;
        if (!overflows()) return;
        const base = parseFloat(window.getComputedStyle(delivery).fontSize) || 14;
        const floor = Math.max(10, base * 0.9);
        let size = base;
        while (overflows() && size - 0.25 >= floor) { size -= 0.25; delivery.style.fontSize = `${size}px`; }
        if (overflows()) { delivery.style.fontSize = ''; delivery.classList.add('mn-delivery--wrap'); }
      };
      const render = () => {
        const { today, minutes } = londonNow();
        const beforeCutoff = minutes < CUTOFF_HOUR * 60;
        const dispatch = isBusinessDay(today) && beforeCutoff ? today : nextBusinessDay(today);
        const daysUntilCutoff = Math.round((dispatch.getTime() - today.getTime()) / DAY);
        const minutesLeft = daysUntilCutoff * 1440 + CUTOFF_HOUR * 60 - minutes;
        const hours = Math.floor(minutesLeft / 60);
        const mins = minutesLeft % 60;
        const end = addBusinessDays(dispatch, MAX_DAYS);
        const countdown = hours > 0 ? `${unit(hours, S.h || 'h')} ${unit(mins, S.m || 'm')}` : unit(mins, S.m || 'm');
        const values = { '[countdown]': countdown, '[date]': fmt.format(end) };
        if (!textEl) return;
        textEl.textContent = '';
        const fillParts = (container, text) => {
          text.split(/(\[countdown\]|\[date\])/).forEach((part) => {
            if (values[part] !== undefined) {
              const b = document.createElement('b');
              b.textContent = values[part];
              b.setAttribute(part === '[countdown]' ? 'data-delivery-countdown' : 'data-delivery-window', '');
              container.appendChild(b);
            } else if (part) {
              container.appendChild(document.createTextNode(part));
            }
          });
        };
        // Two unbreakable halves split at the arrow, so a forced wrap only ever breaks there.
        const arrow = template.indexOf('→');
        const halves = arrow > -1 ? [template.slice(0, arrow + 1).trimEnd(), template.slice(arrow + 1).trimStart()] : [template];
        halves.forEach((half, i) => {
          if (i > 0) textEl.appendChild(document.createTextNode(' '));
          const span = document.createElement('span');
          span.className = 'mn-delivery__part';
          fillParts(span, half);
          textEl.appendChild(span);
        });
        delivery.hidden = false;
        fit();
      };
      render();
      setInterval(render, 30000);
      fitters.push(fit);
    };
    root.querySelectorAll('[data-delivery]').forEach(initDelivery);
    const refit = () => fitters.forEach((fn) => fn());
    let refitTimer = 0;
    window.addEventListener('resize', () => { clearTimeout(refitTimer); refitTimer = setTimeout(refit, 150); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refit).catch(() => {});
    window.addEventListener('load', refit);
    refit();

    /* ---------------- FAQ accordion: one answer open at a time ---------------- */
    const faqs = [...root.querySelectorAll('.mn-faq details')];
    faqs.forEach((item) => item.addEventListener('toggle', () => {
      if (!item.open) return;
      faqs.forEach((other) => { if (other !== item && other.open) other.open = false; });
    }));

    /* ---------------- Send it to the group chat ---------------- */
    // The phone's share sheet where there is one, otherwise copy the link. Hidden when neither works.
    const share = root.querySelector('[data-share]');
    const shareDone = root.querySelector('[data-share-done]');
    if (share && (navigator.share || (navigator.clipboard && navigator.clipboard.writeText))) {
      share.hidden = false;
      let doneTimer = 0;
      share.addEventListener('click', async () => {
        const url = share.dataset.shareUrl || window.location.href.split('?')[0];
        if (navigator.share) {
          try {
            await navigator.share({ title: share.dataset.shareTitle, text: share.dataset.shareText, url });
          } catch (error) {
            // Share sheet closed without sharing.
          }
          return;
        }
        try {
          await navigator.clipboard.writeText(`${share.dataset.shareText} ${url}`);
          if (shareDone) {
            shareDone.hidden = false;
            window.clearTimeout(doneTimer);
            doneTimer = window.setTimeout(() => { shareDone.hidden = true; }, 4000);
          }
        } catch (error) {
          // Clipboard blocked by the browser: nothing to show.
        }
      });
    }

    /* ---------------- Sticky buy bar ---------------- */
    const cartDrawer = root.querySelector('[data-cart]');
    const sticky = root.querySelector('[data-sticky]');
    let stickyAllowed = false;
    const updateSticky = () => {
      if (!sticky) return;
      const show = stickyAllowed && (!cartDrawer || cartDrawer.hidden);
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
    };
    if (sticky && atcButton) {
      // Shows once Add to Cart is above the screen, and steps aside when the footer comes in so it
      // never covers the policy links or the copyright line. Checked on every scroll (capture phase,
      // because Horizon scrolls .page-wrapper on desktop), which also catches anchor jumps.
      const footerEl = root.querySelector('.mn-footer');
      let stickyRaf = 0;
      const checkSticky = () => {
        stickyRaf = 0;
        const footerIn = footerEl ? footerEl.getBoundingClientRect().top < window.innerHeight : false;
        const next = atcButton.getBoundingClientRect().bottom < 0 && !footerIn;
        if (next !== stickyAllowed) { stickyAllowed = next; updateSticky(); }
      };
      const queueSticky = () => { if (!stickyRaf) stickyRaf = requestAnimationFrame(checkSticky); };
      document.addEventListener('scroll', queueSticky, { capture: true, passive: true });
      window.addEventListener('resize', queueSticky);
      checkSticky();
      const cta = sticky.querySelector('[data-sticky-cta]');
      if (cta) cta.addEventListener('click', (event) => {
        event.preventDefault();
        const deals = root.querySelector('[data-deals]');
        if (deals) deals.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    }

    /* ---------------- Cart drawer ---------------- */
    if (!cartDrawer || !atcButton) { syncDeals(); renderRows(); return; }
    const cartCheckout = root.querySelector('[data-cart-checkout]');
    const cartStatus = root.querySelector('[data-cart-status]');
    const cartScroll = root.querySelector('[data-cart-scroll]');
    const linesEl = root.querySelector('[data-cart-lines]');
    const saveEl = root.querySelector('[data-cart-save]');
    const totalEl = root.querySelector('[data-cart-total]');
    const titleEl = root.querySelector('[data-cart-title]');
    const upsell = root.querySelector('[data-cart-upsell]');
    const upsellButton = root.querySelector('[data-cart-upsell-btn]');
    const totalsEl = root.querySelector('.mn-cart__totals');
    const cartOpenButton = root.querySelector('[data-cart-open]');
    const cartCountEl = root.querySelector('[data-cart-count]');
    const cartRoot = (root.dataset.rootUrl || '/').replace(/\/?$/, '/');
    const cartPath = (path) => `${cartRoot}${path.replace(/^\/+/, '')}`;
    let cartBusy = false;
    let lastFocus = null;

    const setStatus = (text, isError = false) => {
      cartStatus.textContent = text || '';
      cartStatus.hidden = !text;
      cartStatus.classList.toggle('is-error', isError);
    };
    const setBusy = (busy) => {
      cartBusy = busy;
      cartDrawer.classList.toggle('is-busy', busy);
      atcButton.disabled = busy;
      if (upsellButton) upsellButton.disabled = busy;
      if (busy) cartCheckout.disabled = true;
    };
    // Safari doesn't focus buttons on click, so callers pass the button that opened the drawer.
    const openDrawer = (opener) => {
      if (!cartDrawer.hidden) return;
      lastFocus = opener || document.activeElement;
      cartDrawer.hidden = false;
      if (cartScroll) cartScroll.scrollTop = 0;
      lockScroll(true);
      updateSticky();
      window.requestAnimationFrame(() => {
        cartDrawer.classList.add('is-open');
        refit();
        const close = cartDrawer.querySelector('.mn-cart__close');
        if (close) close.focus();
      });
    };
    const closeDrawer = (restoreFocus = true) => {
      if (cartDrawer.hidden) return;
      cartDrawer.classList.remove('is-open');
      lockScroll(false);
      window.setTimeout(() => {
        cartDrawer.hidden = true;
        updateSticky();
        if (restoreFocus && lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }, 260);
    };
    const cartRequest = async (path, options = {}) => {
      const response = await fetch(cartPath(path), {
        ...options,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', ...(options.headers || {}) }
      });
      const body = await response.json();
      if (!response.ok) throw new Error(body.description || body.message || 'Shopify could not update the cart.');
      return body;
    };
    const sized = (url, width) => (url ? `${url}${url.indexOf('?') === -1 ? '?' : '&'}width=${width}` : '');
    const setCount = (count) => {
      if (!cartCountEl) return;
      cartCountEl.textContent = String(count);
      cartCountEl.hidden = !(count > 0);
    };
    const renderCart = (cart) => {
      const count = cart.item_count || 0;
      setCount(count);
      if (totalsEl) totalsEl.hidden = count === 0;
      if (count === 0) titleEl.textContent = S.cartEmpty || 'Your cart is empty';
      else titleEl.textContent = count === 1 ? (S.cartOne || '1 Jumper') : fill(S.cartMany, { n: count });
      linesEl.textContent = '';
      cart.items.forEach((item) => {
        const li = document.createElement('li');
        li.className = 'mn-line';
        const img = document.createElement('img');
        img.src = sized(item.image, 160);
        img.alt = '';
        img.width = 64;
        img.height = 64;
        const copy = document.createElement('div');
        copy.className = 'mn-line__copy';
        const name = document.createElement('strong');
        name.textContent = item.product_title;
        const variant = document.createElement('span');
        variant.textContent = [item.variant_title, item.quantity > 1 ? fill(S.cartQty, { n: item.quantity }) : ''].filter(Boolean).join(' ');
        copy.append(name, variant);
        const price = document.createElement('div');
        price.className = 'mn-line__price';
        if (item.original_line_price > item.final_line_price) {
          const was = document.createElement('s');
          was.textContent = formatMoney(item.original_line_price);
          price.appendChild(was);
        }
        const now = document.createElement('span');
        now.textContent = formatMoney(item.final_line_price);
        price.appendChild(now);
        li.append(img, copy, price);
        linesEl.appendChild(li);
      });
      const saved = cart.total_discount || 0;
      saveEl.hidden = !(saved > 0);
      saveEl.textContent = saved > 0 ? fill(S.cartSave, { amount: formatMoney(saved) }) : '';
      totalEl.textContent = formatMoney(cart.total_price);
      if (upsell) upsell.hidden = !(data.connected && count === 1);
      cartCheckout.disabled = count === 0;
    };
    const variantFor = (jumper) => (data.variants || []).find((v) => v.colour === jumper.colour && v.size === jumper.size) || null;
    // Every jumper needs a size, and the variant must exist and be for sale. Returns the variants or null.
    const pickVariants = () => {
      for (let i = 0; i < jumpers.length; i += 1) {
        if (!jumpers[i].size) {
          setNote(i, fill(S.needSize, { n: i + 1 }));
          focusRow(i);
          return null;
        }
      }
      if (!data.connected) return [];
      const picked = [];
      for (let i = 0; i < jumpers.length; i += 1) {
        const variant = variantFor(jumpers[i]);
        if (!variant || variant.available === false) {
          setNote(i, S.soldOut || 'Sorry, that one is sold out.');
          focusRow(i);
          return null;
        }
        picked.push(variant);
      }
      return picked;
    };
    const addToCart = async () => {
      if (cartBusy) return;
      Object.keys(notes).forEach((i) => setNote(Number(i), ''));
      const picked = pickVariants();
      if (!picked) return;
      openDrawer(atcButton);
      if (!data.connected) {
        linesEl.textContent = '';
        totalEl.textContent = '';
        saveEl.hidden = true;
        if (upsell) upsell.hidden = true;
        cartCheckout.disabled = true;
        setStatus(S.preview || 'Preview only: checkout is switched off.');
        return;
      }
      setBusy(true);
      setStatus(S.updating || 'Updating your order…');
      try {
        // The drawer is the order: replace whatever was in the cart with the jumpers picked here.
        const current = await cartRequest('cart.js');
        const updates = current.items.reduce((result, item) => { result[item.key] = 0; return result; }, {});
        if (Object.keys(updates).length) await cartRequest('cart/update.js', { method: 'POST', body: JSON.stringify({ updates }) });
        const grouped = new Map();
        picked.forEach((variant) => grouped.set(variant.id, (grouped.get(variant.id) || 0) + 1));
        const items = [...grouped].map(([id, quantity]) => ({ id, quantity, properties: { _nutmas_pack: String(pack) } }));
        await cartRequest('cart/add.js', { method: 'POST', body: JSON.stringify({ items }) });
        const cart = await cartRequest('cart.js');
        renderCart(cart);
        setStatus('');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      } catch (error) {
        cartCheckout.disabled = true;
        setStatus(S.cartError || error.message || 'The cart could not be updated. Please try again.', true);
      } finally {
        setBusy(false);
      }
    };

    // Header cart button: open the drawer on whatever is in the cart right now.
    const showCart = async () => {
      if (cartBusy || !data.connected) return;
      openDrawer(cartOpenButton);
      setBusy(true);
      setStatus(S.loading || 'Loading your order…');
      try {
        renderCart(await cartRequest('cart.js'));
        setStatus('');
      } catch (error) {
        setStatus(S.cartError || error.message || 'The cart could not be loaded. Please try again.', true);
      } finally {
        setBusy(false);
      }
    };

    atcButton.addEventListener('click', addToCart);
    if (cartOpenButton) cartOpenButton.addEventListener('click', showCart);
    cartDrawer.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', () => closeDrawer()));
    // "Add one for your mate": back to the page with the 2-jumper deal and Jumper 2 ready for a size.
    if (upsellButton) {
      upsellButton.addEventListener('click', () => {
        closeDrawer(false);
        setPack(2);
        setNote(1, S.upsellHint || '', true);
        window.setTimeout(() => focusRow(1), 280);
      });
    }
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (guide && !guide.hidden) closeGuide();
      else if (!cartDrawer.hidden) closeDrawer();
    });
    syncDeals();
    renderRows();
  };

  const boot = () => document.querySelectorAll('[data-mn]:not([data-mn-ready])').forEach((root) => {
    root.setAttribute('data-mn-ready', '');
    init(root);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
